import { EFieldType } from './field-type.enum';
import { Field } from '../../../services';

export class FieldTool {

  static readonly basicLocalizableProperties = ['label', 'isRequiredMessage'];
  static readonly basicUnlocalizableProperties = ['isRequired'];


  static readonly inputLocalizableProperties = ['isUniqueMessage',
  'isMinLengthMessage',
  'isMaxLengthMessage',
  'patternMessage',
  'placeholder',
  'defaultValue'];
  static readonly inputUnlocalizableProperties = ['isUnique', 'minLength', 'maxLength', 'pattern'];

  static readonly fileLocalizableProperties = ['mustBeImageMessage', 'allowedExtensionMessage'];
  static readonly fileUnlocalizableProperties = ['mustBeImage', 'allowedExtensions', 'minItems', 'maxItems'];

  static readonly textAreaLocalizableProperties = ['placeholder', 'defaultValue'];
  static readonly textAreaUnlocalizableProperties = [];


  static readonly mailLocalizableProperties = ['placeholder'];
  static readonly mailUnlocalizableProperties = [];

  static readonly radioLocalizableProperties = [];
  static readonly radioUnlocalizableProperties = ['schemaIds'];

  static readonly selectLocalizableProperties = [];
  static readonly selectUnlocalizableProperties = ['schemaIds'];

  static readonly validPatterns = {
    'email': '^[a-zA-Z0-9.!#$%\u0026\u2019*\u002B\\/=?^_\u0060{|}~-]\u002B@[a-zA-Z0-9-]\u002B(?:.[a-zA-Z0-9-]\u002B)*$',

    'phone': '^\\(*\\\u002B*[1-9]{0,3}\\)*-*[1-9]{0,3}[-. /]*\\(*[2-9]\\d{2}\\)*[-. /]*\\d{3}[-. /]*\\d{4} *e*x*t*\\.* *\\d{0,4}$',

    'slug': '^[a-z0-9]\u002B(\\-[a-z0-9]\u002B)*$',

    'url': '^(?:http(s)?:\\/\\/)?[\\w.-]\u002B(?:\\.[\\w\\.-]\u002B)\u002B[\\w\\-\\._~:\\/?#%[\\]@!\\$\u0026\u0027\\(\\)\\*\\\u002B,;=.]\u002B$',
  }

  static generateSquidexValidField(fieldType: EFieldType, isLocalized = false): Field {
    const field = new Field();

    switch (fieldType) {
      case EFieldType.INPUT:
      field.properties.fieldType = 'String';
      field.properties.editor = 'Input';
      break;
      case EFieldType.FILE:
      field.properties.fieldType = 'Assets';
      field.properties.editor = 'Import';
      break;
      case EFieldType.TEXTAREA:
      field.properties.fieldType = 'String';
      field.properties.editor = 'TextArea';
      break;
      case EFieldType.CHECKBOX:
      field.properties.fieldType = 'Boolean';
      field.properties.editor = 'Checkbox';
      break;
      case EFieldType.RADIO:
      field.properties.fieldType = 'References';
      field.properties.editor = 'List';
      break;
      case EFieldType.SELECT:
      field.properties.fieldType = 'References';
      field.properties.editor = 'Dropdown';
      break;
      case EFieldType.SELECT_MULTIPLE:
      field.properties.fieldType = 'References';
      field.properties.editor = 'Checkboxes';
      break;
      case EFieldType.DATE:
      field.properties.fieldType = 'DateTime';
      field.properties.editor = 'Date';
      break;
      case EFieldType.MAIL:
      field.properties.pattern = '^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$';
      field.properties.fieldType = 'String';
      field.properties.editor = 'Input';
      break;
      case EFieldType.ORDONNABLE_SELECT_MULTIPLE:
      field.properties.fieldType = 'References';
      field.properties.editor = 'Tags';
      break;
    }

    field.properties.inlineEditable = false;
    field.properties.isRequired = false;
    field.properties.isUnique = false;

    if (isLocalized) {
      field.partitioning = 'language';
    } else {
      field.partitioning = 'invariant';
    }

    return field;
  }

  static getUnlocalizableFieldProperties(fieldType: EFieldType): string[] {
    let unlocalizableProperties = this.basicUnlocalizableProperties;

    switch (fieldType) {
      case EFieldType.INPUT:
      unlocalizableProperties = unlocalizableProperties.concat(this.inputUnlocalizableProperties);
      break;
      case EFieldType.FILE:
      unlocalizableProperties = unlocalizableProperties.concat(this.fileUnlocalizableProperties);
      break;
      case EFieldType.RADIO:
      unlocalizableProperties = unlocalizableProperties.concat(this.radioUnlocalizableProperties);
      break;
      case EFieldType.SELECT:
      unlocalizableProperties = unlocalizableProperties.concat(this.selectUnlocalizableProperties);
      break;
      case EFieldType.SELECT_MULTIPLE:
      unlocalizableProperties = unlocalizableProperties.concat(this.selectUnlocalizableProperties);
      break;
      case EFieldType.ORDONNABLE_SELECT_MULTIPLE:
      unlocalizableProperties = unlocalizableProperties.concat(this.selectUnlocalizableProperties);
      break;

    }

    return unlocalizableProperties;
  }


  static getLocalizableFieldProperties(fieldType: EFieldType): string[] {
    let properties = this.basicLocalizableProperties;

    switch (fieldType) {
      case EFieldType.INPUT:
      properties = properties.concat(this.inputLocalizableProperties);
      break;

      case EFieldType.TEXTAREA:
      properties = properties.concat(this.textAreaLocalizableProperties);
      break;

      case EFieldType.FILE:
      properties = properties.concat(this.fileLocalizableProperties);
      break;

      case EFieldType.MAIL:
      properties = properties.concat(this.mailLocalizableProperties);
      break;
    }

    return properties;
  }


  static getTypeFromField(field: Field): EFieldType {

    if (field.properties.fieldType === 'Assets') {
      return EFieldType.FILE;
    }

    switch (field.properties.editor) {
      case 'Input':
      if (field.properties.pattern === '^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$') {
        return EFieldType.MAIL;
      }
      else {
        return EFieldType.INPUT;
      }
      case 'TextArea':
      return EFieldType.TEXTAREA;
      case 'Checkbox':
      return EFieldType.CHECKBOX;
      case 'List':
      return EFieldType.RADIO;
      case 'Dropdown':
        if(field.properties.fieldType == "String" && field.properties.allowedValues && field.properties.allowedValues.length > 0) {
          return EFieldType.STRING_SELECT;
        }
      return EFieldType.SELECT;
      case 'Checkboxes':
      return EFieldType.SELECT_MULTIPLE;
      case 'Date':
      return EFieldType.DATE;
      case 'Tags':
      return EFieldType.ORDONNABLE_SELECT_MULTIPLE;
      case 'Html':
      return EFieldType.MONACO_HTML;
      default:
      return EFieldType.DATE;
    }
  }

}

